import { defineComponent as _defineComponent } from 'vue'
import ModuleContainer from "@/components/Map/ModuleContainer.vue";
import { ListView } from "@/interface/datasource/list";
import { onBeforeUnmount, onMounted, ref } from "vue";
import { eventBus, EVENTBUS_TYPE } from "@/utils/event-bus";

export default /*#__PURE__*/_defineComponent({
  __name: 'layer-component',
  setup(__props) {

const components_show = ref<
  {
    component: any;
    id: string;
    attr: any;
  }[]
>([]);
function onRemoveComponent(item: { id: string }) {
  let index = components_show.value.findIndex((x) => x.id == item.id);
  if (index < 0) {
    return;
  }
  components_show.value.splice(index, 1);
}
function onAddComponent({
  component,
  item,
  option,
  id
}: {
  component: any;
  item: ListView;
  option: any;
  id: string;
}) {
  components_show.value.push({
    id,
    attr: { item, option },
    component
  });
}
onMounted(() => {
  eventBus.on(EVENTBUS_TYPE.COMPONENT.ADD, onAddComponent);
  eventBus.on(EVENTBUS_TYPE.COMPONENT.REMOVE, onRemoveComponent);
});
onBeforeUnmount(() => {
  eventBus.off(EVENTBUS_TYPE.COMPONENT.ADD, onAddComponent);
  eventBus.on(EVENTBUS_TYPE.COMPONENT.REMOVE, onRemoveComponent);
});

return { __sfc: true,components_show, onRemoveComponent, onAddComponent, ModuleContainer }
}

})